import React, { useRef, useState } from "react";
import { useCart } from './cartcontext'
import Header from './Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Link, useNavigate } from 'react-router-dom';
import "./Home.css";
import Footer from "./footer";
import { useEffect } from "react";
import axios from "axios";
import api from '../Components/api'
import Carousel from 'react-bootstrap/Carousel';
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import Swal from 'sweetalert2';
import shampoo from '../Components/Assets/shampoo.png';
import facewash from '../Components/Assets/facewash.png';
import hairoil from '../Components/Assets/hair oil.png';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { FaCheckCircle } from "react-icons/fa";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";



function Home1() {
  // const [cartMessage, setCartMessage] = useState("");
  const [comboProduct, setcomboproduct] = useState([])
  const [singleProduct, setsingleProduct] = useState([])
  const [showAll1, setShowAll1] = useState(false);
  const [cartMessage, setCartMessage] = useState({}); // Individual messages for each product
  const [buttonColors, setButtonColors] = useState({}); // Track button color per product


  const navigatecategory=(data)=>
    {
    navigate('/categoryproduct',{state:data})
    }

const {cart,setcart}=useCart()

  useEffect(()=>
  {
    getproduct()
  },[])

 
const[product1,setproduct1]=useState([])
  const getproduct=async()=>
  {
    try {
      const resp=await api.get("getproduct")
      setproduct1(resp.data.product)
      setcomboproduct(resp.data.product.filter((item)=>item.product_type==="combo"))
      setsingleProduct(resp.data.product.filter((item)=>item.product_type==="single"))
      // setcart(resp.data.product)
      
    } catch (error) {
      console.log(error);
      
    }
  }
  const visibleCombo = showAll1 ? comboProduct : comboProduct.slice(0, 4);

  console.log(visibleCombo);
  
  const[fetchbanner,setfetchbanner]=useState([])
  const [sliderImages, setSliderImages] = useState([]);
  const [banners,setbanners] =useState([]);

  useEffect(() => {
    fetchSliderImages();
  }, []);

  const fetchSliderImages = async () => {
    try {
      const response = await api.get("getAllBanners"); // Replace with your API endpoint
      console.log(response);
      
      setfetchbanner(response.data.banner)
      // Filter only sliderBannerImage data
      const sliderData = response.data.banner.filter((banner) => banner.sliderBannerImage);
      setSliderImages(sliderData);

      const productData = response.data.banner.filter((banner) => banner.productBannerImage);
      setbanners(productData.flatMap((item) => item.productBannerImage)); // Derive banners directly
      
      

    } catch (error) {
      console.error("Error fetching slider images:", error);
    }
  };

  useEffect(() => {
    console.log("Banners updated:", banners);
  }, [banners]);
  

  const Combo = [
    {
      _id: "1",
      product_name: "At KIONA, we believe that great hair starts with proper care. Whether you want to nourish,",
      product_image: shampoo, 
      description: "repair, or protect your hair, our products are designed to meet every need. From strengthening shampoos to deep conditioning treatments, our range offers everything you need for soft, shiny, and manageable hair. Discover the secret to healthier hair today – when your hair looks good, you feel even better.",
      product_price: 1196,
      product_quantity1: 1,
    },
    {
      _id: "2",
      product_name: "Glow from Within with Our Face Care Range",
      product_image: facewash,
      description: "Radiant, smooth skin starts with the right care. At KIONA, we offer a curated selection of face care products to cleanse, hydrate, and rejuvenate your skin. Whether you're looking to tackle dryness, fine lines, or acne, our gentle yet effective formulas are designed to reveal your natural glow. Pamper your skin with the care it deserves, and feel confident in your beautiful complexion.",
      product_price: 1045,
      product_quantity1: 1,
    },
    {
      _id: "3",
      product_name: "Nourish and Pamper Your Skin with Our Body Care Collection",
      product_image: hairoil,
      description: "Treat your skin to the ultimate luxury with our body care essentials. From hydrating lotions to exfoliating scrubs, kIONA offers products that cleanse, moisturize, and smooth your skin, leaving it soft and radiant. Indulge in a soothing routine that not only nourishes your body but also refreshes your senses. Experience the perfect balance of care and comfort every day.",
      product_price: 1045,
      product_quantity1: 1,
    },
  ];

  


   


      

  const handleprouctadd = (product) => {
    const isProductInCart = cart.some((item) => item._id === product._id);
  
    if (!isProductInCart) {
      // Add product to the cart
      setcart([...cart, product]);
  
      // Change button color for the clicked product
      setButtonColors((prev) => ({
        ...prev,
        [product._id]: "#FF5F00",
      }));
  
      // Set cart message
      setCartMessage((prev) => ({
        ...prev,
        [product._id]: "Your product has been added to the cart!",
      }));
  
      // Hide the message after 2 seconds
      setTimeout(() => {
        setCartMessage((prev) => ({
          ...prev,
          [product._id]: "",
        }));
      }, 2000);
    } else {
      Swal.fire({
        title: "Warning!",
        text: "Product already in your cart",
        icon: "warning",
        confirmButtonText: "OK",
      });
    }
  };
  


    



    //   const handleprouctadd = (product) => {
    //     console.log('Adding product to cart:', product);
    //     setcart([...cart, product]);
    //   };
    // console.log(cart);
    // console.log(cart.length);


   
  

   // get all review of customer

   const [loading, setLoading] = useState(true);
   const [reviews, setReviews] = useState([]); // Initialize as an array
 
   // Function to fetch reviews
   const fetchReview = async () => {
     setLoading(true);
     try {
       const response = await api.get("allreview"); // Replace with actual endpoint
       if (response?.status === 200) {
         setReviews(response.data); // Update the state correctly
         
       }
     } catch (error) {
       console.error("Error fetching reviews:", error.response || error.message);
      //  Swal.fire({
      //    title: "Error!",
      //    text: "Failed to fetch reviews. Please try again.",
      //    icon: "error",
      //    confirmButtonText: "OK",
      //  });
     } finally {
       setLoading(false);
     }
   };
 
   // Fetch reviews when component mounts
   useEffect(() => {
    fetchReview();
   }, []);
 
   // Function to render stars
   const renderStars = (rating) => {
     return "⭐".repeat(rating);
   };
 


    // Function to render stars based on rating
    // const renderStars = (rating) => {
    //   const totalStars = 5;
    //   const stars = [];
    //   for (let i = 1; i <= totalStars; i++) {
    //     stars.push(
    //       <i
    //         key={i}
    //         className={`bi bi-star${i <= rating ? "-fill" : ""}`}
    //         style={{
    //           color: i <= rating ? "#ffc107" : "#ddd",
    //           marginRight: "3px",
    //         }}
    //       ></i>
    //     );
    //   }
    //   return stars;
    // };

    const navigate=useNavigate()

    const handleProductClick = (id) => {
      navigate(`/product/${id}`); // Navigate to specific product details page
    };




    const [blogPosts, setBlogPosts] = useState([]);
  const [showAll, setShowAll] = useState(false);

  // Fetch blog posts from the backend
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await api.get("getblog"); // Replace with your API endpoint
        setBlogPosts(response.data); // Assuming the API returns an array of blogs
      } catch (error) {
        console.error("Error fetching blogs:", error.message || error);
      }
    };

    fetchBlogs();
  }, []);
   
    
  const visibleBlogs = showAll ? blogPosts : blogPosts.slice(0, 3);

  const [visibleProducts, setVisibleProducts] = useState(4);

  const handleViewMore = () => {
    setVisibleProducts((prevCount) => prevCount + 4); // Show 4 more products each time
  };

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + " ...";
    }
    return text;
  };


   // Group products into slides (e.g. 4 per slide)
  // const chunkSize = 1;
  // const slides = [];
  // for (let i = 0; i < singleProduct.length; i += chunkSize) {
  //   slides.push(singleProduct.slice(i, i + chunkSize));
  // }
const paginationRef = useRef(null);


  return (
    <div>
        <Header/>
      

{/* banner start----------------------------------------------------------------------------------------------- */}

<div className="w-full mt-24">
  <Carousel data-bs-theme="dark" className="relative overflow-hidden">
    {sliderImages.map((banner, index) => (
      <Carousel.Item key={index}>

        <div
          className="
            w-full 
            h-[35vh]        /* ⭐ Small height on mobile */
            sm:h-[45vh]
            md:h-[65vh] 
            lg:h-[80vh]
            relative overflow-hidden
          "
        >
          <img
            src={banner.sliderBannerImage}
            alt={`Slide ${index + 1}`}
            onClick={() => window.location.href = banner.bannerLink}

            className="
              w-full h-full 
              object-cover     /* ⭐ No black/white gaps */
              transition-transform duration-[2000ms] ease-out
              md:hover:scale-105
            "
          />
        </div>

      </Carousel.Item>
    ))}
  </Carousel>
</div>


{/* banner main end--------------------------------------------------------------------------------------------- */}


{/* content start------------------------------------------------------------------- */}
<div className="bg-[#f0f5ff] w-full py-16 px-6 text-center">
  <div className="max-w-4xl mx-auto animate-fadeIn">
    <h1
      id="content1"
      className="text-3xl md:text-5xl font-bold text-gray-900 font-serif mb-6"
    >
      Kiona Skin Care: Embrace Your Natural Glow
    </h1>

    <p className="text-base md:text-lg text-gray-600 leading-relaxed font-serif">
      Founded in 2020 by a team of skincare professionals and holistic health
      experts, <strong className="text-gray-800">Kiona Skin Care</strong> was born out of a passion
      to bring back the purity of nature to your skincare routine. In a world
      where harsh chemicals dominate, we believe in the power of organic and
      plant-based ingredients that nurture and protect your skin.
      <strong className="text-gray-800">
        Our products, including face washes, shampoos, and serums, are crafted
        with love and care, using only the finest natural ingredients.
      </strong>
    </p>

    {/* Button */}
    <button
      onClick={() => navigate("/aboutus")}
      className="mt-8 px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg 
                 hover:bg-blue-700 transition duration-300 shadow-md hover:shadow-lg
                 active:scale-95"
    >
      More About
    </button>
  </div>
</div>

{/* content end--------------------------------------------------------------------------- */}

{/* product cart section------------------------------------------------------------------------------------- */}


 

 <div className="bg-[#f0f5ff] p-4">
  <h1 className="text-3xl font-extrabold text-center text-gray-800 mb-8 tracking-wide">
    ✨ Combo Products ✨
  </h1>

  <div className="container mx-auto px-6 overflow-hidden">

    {/* If 4 or fewer products => show 2×2 grid */}
    {comboProduct.length <= 4 ? (
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {comboProduct.map((product) => (
          <div
            key={product._id}
            className="bg-white shadow-lg rounded-2xl p-3 lg:p-4 flex flex-col relative 
              min-h-[450px] hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
          >
            {/* Image */}
            <div
              className="relative overflow-hidden rounded-xl cursor-pointer"
              onClick={() => navigate(`/product/${product._id}`)}
            >
              <img
                src={product.product_image?.[0]}
                alt={product.product_name}
                className="w-full aspect-[4/4] object-cover hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 right-2 bg-pink-500 text-white text-xs font-semibold px-3 py-1 rounded-full shadow">
                {product.product_sku}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 mt-3 pb-16 text-center">
              <h3 className="text-lg font-semibold text-gray-800 line-clamp-2">
                {product.product_name}
              </h3>

              <p className="text-sm text-gray-500 mt-1">
                ₹{product.product_price} &nbsp;|&nbsp;
                <span className="text-green-600 font-semibold animate-pulse">
                  🟢 In Stock
                </span>
              </p>

              {product.product_benefits?.length > 0 ? (
                <ul className="text-sm text-gray-600 mt-2 list-disc list-inside space-y-1 text-left px-2">
                  {product.product_benefits.slice(0, 2).map((benefit, i) => (
                    <li key={i} className="line-clamp-2">
                      {benefit}
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="text-gray-400 text-sm mt-3 italic">
                  No extra benefits listed
                </div>
              )}
            </div>

            {/* Add to Cart Button */}
 <button
  onClick={() => handleprouctadd(product)}
  className={`w-full py-2 rounded-lg font-semibold text-white transition-all duration-300 shadow-md
    ${
      cart.some((item) => item._id === product._id)
        ? "bg-green-600 hover:bg-green-700"
        : "bg-gradient-to-r from-amber-500 to-yellow-600 hover:from-yellow-500 hover:to-amber-600 hover:shadow-lg"
    }`}
>
  {cart.some((item) => item._id === product._id)
    ? "Added to Cart ✅"
    : "Add to Cart 🛒"}
</button>


          </div>
        ))}
      </div>
    ) : (
      /* If more than 4 products => use swiper slider */
      <>
        <Swiper
          watchOverflow
          modules={[Pagination, Autoplay]}
          spaceBetween={20}
          slidesPerView={1}
          pagination={{ clickable: true, el: paginationRef.current }}
          onBeforeInit={(swiper) => {
            swiper.params.pagination.el = paginationRef.current;
          }}
          breakpoints={{
            480: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 4 },
          }}
          className="mt-10"
        >
          {comboProduct.map((product) => (
            <SwiperSlide key={product._id}>
              <div
                className="bg-white shadow-lg rounded-2xl p-3 lg:p-4 flex flex-col relative 
                  min-h-[450px] hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
              >
                {/* Image */}
                <div
                  className="relative overflow-hidden rounded-xl cursor-pointer"
                  onClick={() => navigate(`/product/${product._id}`)}
                >
                  <img
                    src={product.product_image?.[0]}
                    alt={product.product_name}
                    className="w-full aspect-[4/3] object-cover hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute top-2 right-2 bg-pink-500 text-white text-xs font-semibold px-3 py-1 rounded-full shadow">
                    {product.product_sku}
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 mt-3 pb-16 text-center">
                  <h3 className="text-lg font-semibold text-gray-800 line-clamp-2">
                    {product.product_name}
                  </h3>

                  <p className="text-sm text-gray-500 mt-1">
                    ₹{product.product_price} &nbsp;|&nbsp;
                    <span className="text-green-600 font-semibold animate-pulse">
                      🟢 In Stock
                    </span>
                  </p>

                  {product.product_benefits?.length > 0 ? (
                    <ul className="text-sm text-gray-600 mt-2 list-disc list-inside space-y-1 text-left px-2">
                      {product.product_benefits.slice(0, 2).map((benefit, i) => (
                        <li key={i} className="line-clamp-2">
                          {benefit}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="text-gray-400 text-sm mt-3 italic">
                      No extra benefits listed
                    </div>
                  )}
                </div>

                {/* Add to Cart Button */}
                <div className="absolute bottom-3 left-3 right-3">
                  <button
                    onClick={() => handleprouctadd(product)}
                    className={`w-full py-2 rounded-lg font-semibold text-white transition-all duration-300 ${
                      cart.some((item) => item._id === product._id)
                        ? "bg-green-600 hover:bg-green-700"
                        : "bg-gray-800 hover:bg-gray-900"
                    }`}
                  >
                    {cart.some((item) => item._id === product._id)
                      ? "Added to Cart ✅"
                      : "Add to Cart 🛒"}
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div
          ref={paginationRef}
          className="swiper-pagination mt-6 flex justify-center"
        ></div>
      </>
    )}

    {/* View All Combos */}
    <div className="text-center mt-6">
      <button
        onClick={() => navigate("/combo")}
        className="px-8 py-3 bg-gray-800 text-white rounded-lg shadow hover:bg-gray-900 transition-all duration-300"
      >
        View All Combos →
      </button>
    </div>
  </div>
</div>




{/* --------------------------------------------------------------------------------------------------------------- */}
{/* collection  start----------------------------------------------------------------------- */}
<div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(12, 1fr)",
        gap: "20px",
        padding: "40px",
        backgroundColor: "#fdfaf5",
      }}
    >
      {/* First Row */}
      <div style={{ gridColumn: "span 6" }} className="gallery-item">
        <img
          src="https://wdtlilacdemo.wpengine.com/wp-content/uploads/2023/06/Lilac-Demo-Grid-Banner-Img-2-768x737.webp"
          alt="Body Care"
          className="gallery-img"
        />
        <div className="overlay">
          <h6>KIONA</h6>
          <h5>Hair oil</h5>
          <a  onClick={() => navigatecategory("hair oil")} >View Collections →</a>
        </div>
      </div>

      <div style={{ gridColumn: "span 3" }} className="gallery-item">
        <img
          src="https://wdtlilacdemo.wpengine.com/wp-content/uploads/2023/06/filler-img-10-768x353.webp"
          alt="Face Care"
          className="gallery-img"
        />
          <div className="overlay">
          <h6>KIONA</h6>
          <h5>Face Wash</h5>
          <a onClick={() => navigatecategory("face wash")}>View Collections →</a>
        </div>
      </div>

      <div style={{ gridColumn: "span 3" }} className="gallery-item">
        <img
          src="https://wdtlilacdemo.wpengine.com/wp-content/uploads/2023/06/filler-img-12-768x353.webp"
          alt="Leg Care"
          className="gallery-img"
        />
          <div className="overlay">
          <h6>KIONA</h6>
          <h5>Shampoo</h5>
          <a onClick={() => navigatecategory("shampoo")}>View Collections →</a>
        </div>
      </div>

      {/* Second Row */}
      <div style={{ gridColumn: "span 6" }} className="gallery-item">
        <img
          src="https://wdtlilacdemo.wpengine.com/wp-content/uploads/2023/06/Lilac-Demo-Grid-Banner-Img-768x353.webp"
          alt="Hair Care"
          className="gallery-img"
        />
          <div className="overlay">
          <h6>KIONA</h6>
          <h5>Face wash</h5>
          <a onClick={() => navigatecategory("face wash")}>View Collections →</a>
        </div>
      </div>

      <div style={{ gridColumn: "span 6" }} className="gallery-item">
        <img
          src="https://wdtlilacdemo.wpengine.com/wp-content/uploads/2023/06/filler-img-13-768x353.webp"
          alt="Fragrance"
          className="gallery-img"
        />
          <div className="overlay">
          <h6>KIONA</h6>
          <h5>Hair oil</h5>
          <a onClick={() => navigatecategory("hair oil")}>View Collections →</a>
        </div>
      </div>

      <style>{`
        .gallery-item {
          position: relative;
          overflow: hidden;
          border-radius: 12px;
          height: 300px;
          box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
        }

        .gallery-item:hover {
          transform: scale(1.05);
          box-shadow: 0px 12px 30px rgba(0, 0, 0, 0.2);
        }

        .gallery-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 12px;
        }

        .overlay {
          position: absolute;
          top: 20px;
          left: 20px;
          color: #fff;
          backdrop-filter: blur(8px);
          padding: 10px;
        }

        .overlay h6 {
          font-size: 0.9rem;
          opacity: 0.9;
          font-weight: bold;
        }

        .overlay h5 {
          font-size: 1.8rem;
          font-weight: bold;
        }

        .overlay a {
          text-decoration: none;
          font-size: 1rem;
          color: #fff;
          font-weight: bold;
          border-bottom: 2px solid #fff;
          transition: opacity 0.3s ease-in-out;
          opacity: 0.9;
        }

        .overlay a:hover {
          opacity: 1;
        }

        @media (max-width: 1200px) {
          .gallery-item {
            grid-column: span 6 !important;
          }
        }

        @media (max-width: 768px) {
          .gallery-item {
            grid-column: span 12 !important;
            height: 250px;
          }
            #content1{
            color:red;
            }

          .overlay h5 {
            font-size: 1.4rem;
          }
        }

        @media (max-width: 480px) {
          .gallery-item {
            height: 200px;
          }
        }
      `}</style>
    </div>

{/* single products-------------------------------------------------------------------------- */}

   <div
      className="py-4"
      style={{
        background: "linear-gradient(to right, #FFF9B1, #FFB6C1, #FFF9B1)",
      }}
    >
      {/* <h1 className="text-center mb-4" style={{ color: "#333" }}>
        Incredible Products
      </h1> */}

      <div id="productCarousel" className="carousel slide" data-bs-ride="carousel">
        
        <div className="carousel-inner">
          {singleProduct.map((product, index) => (
            <div className={`carousel-item ${index === 0 ? "active" : ""}`} key={product.id}>
              <div className="container d-flex justify-content-center">
                <div className="card shadow-sm text-center border-0" style={{ width: "100%", maxWidth: "320px" }}>
                  <div
                    className="image-container"
                    style={{
                      width: "100%",
                      height: "270px",
                      overflow: "hidden",
                      borderRadius: "10px 10px 0 0",
                      backgroundColor: "#f8f8f8",
                    }}
                  >
                    <img
                      src={product.product_image}
                      alt={product.product_name}
                      className="img-fluid"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        display: "block",
                        margin: "0 auto",
                        padding: "10px",
                      }}
                      onClick={() => navigate(`/product/${product._id}`)}
                    />
                  </div>

                  <div className="card-body">
                    <h6 className="card-title text-truncate">{product.product_name}</h6>
                    <p className="card-text text-muted mb-2">₹{product.product_price}</p>
                    <button
                      className="btn btn-dark w-100"
                      style={{
                        backgroundColor: cart.some(item => item._id === product._id)
                          ? "green"
                          : "rgb(51, 51, 51)",
                        fontWeight: "bold",
                      }}
                      onClick={() => handleprouctadd(product)}
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#productCarousel"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#productCarousel"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>


{/* video secton- start------------------------------------------------------------------- */}

<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "50px",
    backgroundColor: "#c9bba6",
    height: "auto", // Allow height to adjust
    fontFamily: "'Arial', sans-serif",
    flexWrap: "wrap", // Wrap items for smaller screens
  }}
>
  {/* Left Section */}
  <div
    style={{
      maxWidth: "60%",
      flex: "1 1 60%",
      minWidth: "300px",
      marginBottom: "20px",
    }}
  >
    <p
      style={{
        textTransform: "uppercase",
        fontSize: "0.9rem",
        letterSpacing: "1px",
        fontWeight: "600",
        color: "black",
        marginBottom: "10px",
      }}
    >
      Discover Premium Beauty Products
    </p>
    <h1
      style={{
        fontSize: "22px",
        fontWeight: "bold",
        color: "#000",
        marginBottom: "20px",
        lineHeight: "1.2",
      }}
    >
    Experience the power of nature and science with our premium beauty formulas, designed to nourish your skin and hair for a radiant glow.
    </h1>
    <h2 style={{ fontSize: "1.5rem", marginBottom: "15px", color: "#333" }}>
        Why Choose Us?
      </h2>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
  <p style={{ fontSize: "1rem", display: "flex",  gap: "5px", color: "#555", lineHeight: "1" }}>
    <FaCheckCircle color="#28a745" /> Thoughtfully formulated with high-quality ingredients
  </p>
  <p style={{ fontSize: "1rem", display: "flex",  gap: "5px", color: "#555", lineHeight: "1" }}>
    <FaCheckCircle color="#28a745" /> Designed for all skin and hair types
  </p>
  <p style={{ fontSize: "1rem", display: "flex",  gap: "5px", color: "#555", lineHeight: "1" }}>
    <FaCheckCircle color="#28a745" /> Backed by happy customers
  </p>
</div>
<p style={{color:"black"}}>Explore our collection and let your beauty shine naturally!</p>



<Link to="/combo" style={{ textDecoration: "none" }}>
  <button
    style={{
      padding: "10px 20px",
      backgroundColor: "#f5e6c8",
      border: "none",
      borderRadius: "5px",
      fontSize: "1rem",
      fontWeight: "bold",
      color: "#000",
      cursor: "pointer",
      transition: "all 0.3s ease",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#e5d4b8")}
    onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#f5e6c8")}
  >
    Explore Now
  </button>
</Link>

  </div>

  {/* Right Section */}
  <div
    style={{
      textAlign: "center",
      flex: "1 1 30%",
      minWidth: "200px",
    }}
  >
    <div
      style={{
        width: "80px",
        height: "80px",
        borderRadius: "50%",
        backgroundColor: "#f9f4ec",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          width: "20px",
          height: "20px",
          borderLeft: "10px solid transparent",
          borderRight: "10px solid transparent",
          borderTop: "15px solid #000",
        }}
      ></div>
    </div>
    <p
      style={{
        marginTop: "10px",
        fontSize: "0.9rem",
        fontWeight: "600",
        color: "#000",
      }}
    >
      Play Video
    </p>
  </div>

  <style>
    {`
      @media (max-width: 1024px) {
        div[style*="padding: 50px"] {
          padding: 30px; /* Reduce padding for medium screens */
        }

        h1 {
          font-size: 2rem; /* Adjust heading font size */
        }

        button {
          font-size: 0.9rem; /* Adjust button font size */
          padding: 8px 16px;
        }

        div[style*="width: 80px"] {
          width: 70px; /* Adjust play button size */
          height: 70px;
        }

        div[style*="borderTop: 15px solid"] {
          borderTop: 12px solid #000; /* Adjust play icon size */
        }
      }

      @media (max-width: 768px) {
        div[style*="flexWrap"] {
          flex-direction: column; /* Stack sections vertically */
          align-items: center;
          text-align: center;
        }

        div[style*="maxWidth: 60%"] {
          maxWidth: 100%; /* Expand left section */
        }

        div[style*="flex: 1 1 30%"] {
          margin-top: 20px; /* Add space between sections */
        }

        h1 {
          font-size: 1.8rem; /* Adjust heading font size */
        }

        p {
          font-size: 0.9rem; /* Adjust paragraph font size */
        }

        button {
          font-size: 0.8rem; /* Adjust button font size */
          padding: 8px 12px; /* Adjust button padding */
        }

        div[style*="width: 80px"] {
          width: 60px; /* Adjust play button size */
          height: 60px;
        }

        div[style*="borderTop: 15px solid"] {
          borderTop: 10px solid #000; /* Adjust play icon size */
        }
      }

      @media (max-width: 480px) {
        div[style*="flexWrap"] {
          padding: 20px; /* Further reduce padding */
        }

        h1 {
          font-size: 1.5rem; /* Smaller heading */
        }

        p {
          font-size: 0.8rem; /* Smaller text */
        }

        button {
          font-size: 0.7rem; /* Smaller button text */
          padding: 6px 10px;
        }

        div[style*="width: 80px"] {
          width: 50px; /* Smaller play button */
          height: 50px;
        }

        div[style*="borderTop: 15px solid"] {
          borderTop: 8px solid #000; /* Smaller play icon */
        }
      }
    `}
  </style>
</div>

{/* our stander start------------------------------------------------------------------------------- */}
<div style={{backgroundColor:"rgb(255, 255, 255)"}}>
<div className="row" style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginTop: "6rem", marginLeft: "3rem", marginRight: "3rem" }}>
  <h2 style={{textAlign:"center"}}>Everything your skin needs,<br/>
  Nothing it doesn’t</h2>
        <div className="col-md-3" style={{ flex: 1, textAlign: 'center', padding: '20px', backgroundColor: '#f0f0f0', borderRadius: '10px', border: '1px solid #ddd', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', height: '15rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div className="icon-circle">
            <i className="fa-solid fa-seedling" style={{ fontSize: '40px', color: '#fff' }}></i>
          </div>
          <h4 style={{ marginTop: '10px', color: '#333' }}>Pure & Clean</h4>
        </div>
        <div className="col-md-3" style={{ flex: 1, textAlign: 'center', padding: '20px', backgroundColor: '#e3f2fd', borderRadius: '10px', border: '1px solid #ddd', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', height: '15rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div className="icon-circle">
            <i className="fa-solid fa-flask" style={{ fontSize: '40px', color: '#fff' }}></i>
          </div>
          <h4 style={{ marginTop: '10px', color: '#333' }}>Skin Safe Tested</h4>
        </div>
        <div className="col-md-3" style={{ flex: 1, textAlign: 'center', padding: '20px', backgroundColor: '#fff3e0', borderRadius: '10px', border: '1px solid #ddd', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', height: '15rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div className="icon-circle">
            <i className="fa-solid fa-cat" style={{ fontSize: '40px', color: '#fff' }}></i>
          </div>
          <h4 style={{ marginTop: '10px', color: '#333' }}>Ethically Tested</h4>
        </div>
        <div className="col-md-3" style={{ flex: 1, textAlign: 'center', padding: '20px', backgroundColor: '#c8e6c9', borderRadius: '10px', border: '1px solid #ddd', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', height: '15rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div className="icon-circle">
            <i className="fa-brands fa-pagelines" style={{ fontSize: '40px', color: '#fff' }}></i>
          </div>
          <h4 style={{ marginTop: '10px', color: '#333' }}>Free from Parabens</h4>
        </div>
      </div>

      {/* second row */}
      <div className="row" style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginTop: "3rem", marginLeft: "3rem", marginRight: "3rem" }}>
        <div className="col-md-3" style={{ flex: 1, textAlign: 'center', padding: '20px', backgroundColor: '#f0f0f0', borderRadius: '10px', border: '1px solid #ddd', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', height: '15rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div className="icon-circle">
            <i className="fa-solid fa-map" style={{ fontSize: '40px', color: '#fff' }}></i>
          </div>
          <h4 style={{ marginTop: '10px', color: '#333' }}>Made in India</h4>
        </div>
        <div className="col-md-3" style={{ flex: 1, textAlign: 'center', padding: '20px', backgroundColor: '#e3f2fd', borderRadius: '10px', border: '1px solid #ddd', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', height: '15rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div className="icon-circle">
            <i className="fa-solid fa-flask-vial" style={{ fontSize: '40px', color: '#fff' }}></i>
          </div>
          <h4 style={{ marginTop: '10px', color: '#333' }}>No Harsh Surfactants</h4>
        </div>
        <div className="col-md-3" style={{ flex: 1, textAlign: 'center', padding: '20px', backgroundColor: '#fff3e0', borderRadius: '10px', border: '1px solid #ddd', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', height: '15rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div className="icon-circle">
            <i className="fa-solid fa-leaf" style={{ fontSize: '40px', color: '#fff' }}></i>
          </div>
          <h4 style={{ marginTop: '10px', color: '#333' }}>All Natural Ingredients</h4>
        </div>
        <div className="col-md-3" style={{ flex: 1, textAlign: 'center', padding: '20px', backgroundColor: '#c8e6c9', borderRadius: '10px', border: '1px solid #ddd', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', height: '15rem', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <div className="icon-circle">
            <i className="fa-solid fa-droplet" style={{ fontSize: '40px', color: '#fff' }}></i>
          </div>
          <h4 style={{ marginTop: '10px', color: '#333' }}>PH Neutral</h4>
        </div>
      </div>

      </div>

{/*our stander end-----------------------------------------------------------------------------------  */}

{/* combo start----------------------------------------------------------------------------------- */}

<div className="py-12 mt-8 bg-[#f0f5ff]">
  <div className="container mx-auto px-4">
    <div className="space-y-10">
      {Combo.map((product, index) => (
        <div
          key={product._id}
          className={`flex flex-col md:flex-row ${
            index % 2 !== 0 ? "md:flex-row-reverse" : ""
          } bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300`}
        >
          {/* IMAGE */}
          <div className="w-full md:w-1/2 h-64 md:h-auto">
            <img
              src={product.product_image}
              alt={product.product_name}
              className="w-full h-full object-cover"
            />
          </div>

          {/* CONTENT */}
          <div className="w-full md:w-1/2 p-6 flex flex-col justify-center">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">
              {product.product_name}
            </h2>

            <p className="text-gray-600 text-base md:text-lg leading-relaxed text-justify">
              {product.description}
            </p>

            {/* Price (If Needed Later)
            <p className="text-xl font-semibold mt-4 text-pink-600">₹{product.product_price}</p> 
            */}
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

{/* combo end-------------------------------------------------------------------------------------- */}
{/* review */}

<Container
  fluid
  className="py-10 px-4 md:px-16 bg-[#f0f5ff]"
>
  <h1 className="text-center text-3xl md:text-4xl font-extrabold text-gray-800 mb-10 tracking-wide">
    ⭐ Customer Reviews ⭐
  </h1>

  {loading ? (
    <p className="text-center text-gray-500 text-lg">Loading reviews...</p>
  ) : reviews.length > 0 ? (
    <div className="relative">
      <Carousel id="reviewCarousel" interval={1000} indicators={true} controls={true} touch>
        {reviews.map((review, idx) => (
          <Carousel.Item key={idx}>
            <div className="flex justify-center px-2">
              <div
                className="
                  bg-white shadow-lg rounded-2xl p-8 md:p-10 max-w-xl w-full 
                  border border-gray-100 
                  hover:shadow-xl transition-all duration-300
                  text-center
                "
              >
                <h4 className="text-xl font-semibold text-gray-900 mb-2">
                  {review.name}
                </h4>

                <div className="flex justify-center mb-3">
                  {renderStars(review.rating)}
                </div>

                <p className="italic text-gray-600 text-base leading-relaxed">
                  "{review.comment}"
                </p>
              </div>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      {/* CUSTOM BUTTONS */}
      {/* <div className="flex justify-center gap-6 mt-6">
  
        <button
          className="
            bg-purple-600 hover:bg-purple-700 text-white
            px-6 py-2 rounded-full font-semibold shadow-lg 
            transition-all duration-300
          "
          data-bs-target="#reviewCarousel"
          data-bs-slide="prev"
        >
          ◀ Prev
        </button>

    
        <button
          className="
            bg-purple-600 hover:bg-purple-700 text-white
            px-6 py-2 rounded-full font-semibold shadow-lg 
            transition-all duration-300
          "
          data-bs-target="#reviewCarousel"
          data-bs-slide="next"
        >
          Next ▶
        </button>
      </div> */}
    </div>
  ) : (
    <p className="text-center text-gray-500 text-lg">No reviews available.</p>
  )}
</Container>






{/* content */}

{/* blog start-------------------------------------------------------------------------------- */}

{/* <div
  style={{
    fontFamily: "'ITC Modern No 216', serif",
    padding: "40px",
    marginTop: "10px",
    backgroundImage: "url('https://wdtlilacdemo.wpengine.com/wp-content/uploads/2022/09/lef-image-1-298x300.webp')",
    backgroundPosition: "right 50%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "150px auto",
  }}
>
  <div className="container">
    <div style={{ textAlign: "center", marginBottom: "20px" }}>
      <h1 className="kiona-tales">Kiona Tales</h1>
      <div className="empty-div"></div>
    </div>

    
    <div className="row g-4">
      {visibleBlogs.map((post, index) => (
        <div className="col-sm-12 col-md-6 col-lg-4" key={index}>
          <div className="card h-100 shadow-sm">
            <img
              src={post.image}
              className="card-img-top"
              alt={`Blog ${index + 1} Image`}
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "8px",
              }}
            />
            <div className="card-body">
              <h5 className="card-title" style={{ fontSize: "1.25rem", fontWeight: "bold", fontFamily: "'ITC Modern No 216', serif" }}>
                {post.title}
              </h5>
              <p className="card-text text-muted">{post.date}</p>
              <p className="card-text" style={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 3,
                overflow: "hidden",
              }}>
                {post.description}
              </p>
              <a
                className="btn btn-link p-0"
                style={{
                  fontFamily: "'Harmonia Sans', sans-serif",
                  color: "#007bff",
                  textDecoration: "none",
                }}
                onClick={() => navigate("/blog2", { state: post._id })}
              >
                Read more...
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>

   
    <div style={{ textAlign: "center", marginTop: "20px" }}>
      <button
        className="btn btn-dark"
        style={{
          marginTop:"50px",
         
          padding: "10px 20px",
          fontSize: "16px",
          width: "100%",  
          maxWidth: "200px", 
        }}
        onClick={() => navigate("/blog1")}
      >
        View All
      </button>
    </div>
  </div>
</div> */}
{/* blog end---------------------------------------------------------------------------------- */}

<div
  style={{
    // background: "linear-gradient(to bottom right, #dfffbf, #ffeaba)",
    minHeight: "20rem",
    padding:"50px"
  }}
>
  <div className="container-lg py-5">
    <div className="row g-4 justify-content-center">
      {/* Card 1 */}
      <div className="col-12 col-sm-6 col-md-6 col-lg-4">
        <div className="border rounded p-4 text-center shadow bg-light h-100 d-flex flex-column justify-content-between">
          <i className="fa-solid fa-credit-card" style={{ fontSize: "4rem", color: "#007bff" }}></i>
          <div>
            <h4 className="fw-bold">Secure Transactions</h4>
            <p>Your payment information is processed securely and with the utmost care.</p>
          </div>
        </div>
      </div>

      {/* Card 2 */}
      <div className="col-12 col-sm-6 col-md-6 col-lg-4">
        <div className="border rounded p-4 text-center shadow bg-light h-100 d-flex flex-column justify-content-between">
          <i className="fa-solid fa-truck-fast" style={{ fontSize: "4rem", color: "#28a745" }}></i>
          <div>
            <h4 className="fw-bold">Zero-Hassle Shipping</h4>
            <p>Brisk shipping and no-worries returns. Fast and reliable shipping!</p>
          </div>
        </div>
      </div>

      {/* Card 3 */}
      <div className="col-12 col-sm-6 col-md-6 col-lg-4">
        <div className="border rounded p-4 text-center shadow bg-light h-100 d-flex flex-column justify-content-between">
          <i className="fa-solid fa-phone" style={{ fontSize: "4rem", color: "#ffc107" }}></i>
          <div>
            <h4 className="fw-bold">We Love To Talk</h4>
            <p>Call, email, drop a note. You'll find us there on the other side.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
{/* content end */}
<Footer/>


    </div>
  )
}

export default Home1